import styled from 'styled-components';

export const HeadContainer = styled.div`
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin-bottom: 32px;

	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		align-items: normal;
		flex-direction: column;
		gap: 16px;
	}
`;

export const TitlePage = styled.h1`
	align-items: baseline;
	color: ${({ theme }) => theme.colors.principal.orion};
	display: flex;
	font-size: 32px;
	font-weight: 500;
	line-height: 1.1;

	svg {
		height: 40px;
		width: 40px;
	}
`;

export const ButtonsContainer = styled.div`
	display: flex;
	gap: 12px;
`;

export const ContainerActions = styled.div`
	display: flex;
	gap: 4px;
`;

interface SimpleButtonProps {
	borderColor?: string;
	disabled?: boolean;
}

export const SimpleButton = styled.button<SimpleButtonProps>`
	background-color: inherit;
	border: ${({ theme, borderColor, disabled }) =>
		disabled ? '0px' : `1px solid ${borderColor || theme.colors.principal.ceres}`};
	border-radius: 8px;
	cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
	display: grid;
	padding: 10px;
	place-content: center;
	position: relative;
`;

export const SkeletonSVG = styled.div`
	border-radius: 8px;
	height: 22px;
	width: 22px;
`;

export const NewPaymentLinkButton = styled.button`
	background-color: ${({ theme }) => theme.colors.extra.crab};
	border: 0;
	border-radius: 8px;
	color: white;
	cursor: pointer;
	height: 37px;
	min-width: 150px;
	outline: 0;
	padding: 0 12px;
	transition: background-color 0.2s ease-in-out;
	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 100%;
	}

	&:hover {
		background-color: ${({ theme }) => theme.colors.extra.crab}CC;
	}
`;
interface PLCardContainerProps {
	selected: boolean;
	onStart?: boolean;
}
export const PLCardIcon = styled.div<PLCardContainerProps>`
	align-items: center;
	background-color: ${(props) =>
		props.selected ? props.theme.colors.extra.crab : props.theme.colors.principal.air};
	border-radius: 4px;
	display: flex;
	height: 40px;
	justify-content: center;
	margin-right: 10px;
	padding: 5px 8px;
	width: 40px;
`;

export const TableFilterHeader = styled.div`
	display: flex;
	padding-bottom: 32px;
	width: 100%;

	@media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
		display: none;
		position: relative;
	}
`;

export const SelectContainer = styled.div`
	div {
		min-width: 130px;
	}

	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 100%;
	}
`;

export const ProductFilterLabel = styled.div`
	align-items: center;
	display: flex;
	gap: 8px;

	svg {
		height: 25px;
		width: 25px;
	}
`;

interface PLIconContainerProps {
	disabled?: boolean;
}

export const PLIconContainer = styled.div<PLIconContainerProps>`
	opacity: ${(props) => props.disabled && 0.5};
`;
